import PageVisibility from './PageVisibility';
export { default as usePageVisibility } from './usePageVisibility';

export default PageVisibility;